import { PRIVILEGES } from 'constants/privileges';
import { useEffect } from 'react';
import { Box } from '@mui/material';
import { InvoiceService } from 'api';
import { LoadingScreen } from 'components/Loaders/LoadingScreen';
import { useAuth } from 'contexts/authContext';
import { useInvoicesContext } from 'contexts/invoicesContext';
import { useParams } from 'react-router-dom';
import { InvoiceTab } from 'root/pathnames';
import { hasPrivilege } from 'utils/authFunctions.utils';
import { InvoicesTable } from './components/InvoicesTable';

export const InvoicesModule = () => {
  const { user } = useAuth();
  const { tab: invoiceTab } = useParams<{ tab: InvoiceTab }>();

  const { getInvoices, loading, invoicesData } =
    InvoiceService.useGetInvoices();
  const { getTabParams, getSetTabParams } = useInvoicesContext();

  const params = getTabParams(invoiceTab!);
  const setParams = getSetTabParams(invoiceTab!);

  useEffect(() => {
    getInvoices(params).catch((e) => console.log(e));
  }, [getInvoices, params]);

  return (
    <>
      {!invoicesData && <LoadingScreen />}
      <Box
        alignItems='center'
        display='flex'
        flexDirection='column'
        paddingTop='20px'
        sx={{ mx: 4 }}
      >
        {invoicesData &&
          hasPrivilege(PRIVILEGES.Invoices.VIEW_INVOICE_LIST, user) && (
            <InvoicesTable
              data={invoicesData}
              invoicesLoading={loading}
              setParams={setParams}
              onAction={() => getInvoices(params)}
              params={params}
            />
          )}
      </Box>
    </>
  );
};
